import ConnectorViewForm from '../../../../components/connector_views/ConnectorViewForm'

const ConnectorViewEdit = () => {
  return <ConnectorViewForm persisted={true} clone_from={false} />
}

export default ConnectorViewEdit
